import { Space } from "antd";
import { Row } from "antd";
import { ReactNode } from "react";

interface CardTitleProps {
  icon: ReactNode;
  title: string;
  bold?: boolean;
}

export default function CardTitle({ icon, title, bold }: CardTitleProps): React.ReactElement {
  return (
    <Row>
      <Space direction="horizontal" align="center">
        <span className="icon-button-round">{icon}</span>
        <span className={`card-title-text${bold ? " card-title-text--bold" : ""}`}>{title}</span>
      </Space>
    </Row>
  );
}
